// Single source of truth for firmware-dependent numeric limits.

export function getFirmwareLimits(firmware_version) {
	// Trigger / return channel: 0–99 before firmware 6.0, 0–199 from 6.0 on.
	const channel_min = 0;
	const channel_max = firmware_version >= 6.0 ? 199 : 99;

	// Audio Box filename length:
	//   < 5.1  -> 12 characters
	//   = 5.1  -> 45 characters
	//   >= 6.0 -> 31 characters
	let audio_filename_max;
	if (firmware_version < 5.1) {
		audio_filename_max = 12;
	} else if (firmware_version >= 6.0) {
		audio_filename_max = 31;
	} else {
		audio_filename_max = 45;
	}

	return {
		channel_min,
		channel_max,
		audio_filename_max,
		firmware_version,
	};
}
